import { getParents } from '@/lib/event'
import { Event } from '@nostr/tools/wasm'
import { atom, getDefaultStore } from 'jotai'

const store = getDefaultStore()

export const repliesMapAtom = atom<Map<string, Event[]>>(new Map())

export function addReplies(replies: Event[]) {
  store.set(repliesMapAtom, (prev) => {
    let next: Map<string, Event[]> = prev
    let touched = false
    for (const reply of replies) {
      for (const ptr of getParents(reply)) {
        const parent = ptr
          ? 'id' in ptr
            ? ptr.id
            : 'identifier' in ptr
              ? `${ptr.kind}:${ptr.pubkey}:${ptr.identifier}`
              : null
          : reply.tags.find((t) => t[0] === 'q')?.[1]
        if (!parent) continue

        const prevEntries = next.get(parent) || []
        if (!prevEntries.find((evt) => evt.id === reply.id)) {
          if (!touched) {
            next = new Map(prev)
            touched = true
          }
          next.set(parent, [...prevEntries, reply])
        }
      }
    }
    return touched ? next : prev
  })
}
